import EcoImg from 'eco-design/base/eco-img';
import css from './index.module.scss';
import { useLang } from '@/i18n';
import { useEffect, useState } from 'react';
import { Navigation } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';

interface ItemType {
    img: string;
    name: string;
    text: string;
}
const O: React.FC = () => {
    const { t } = useLang('d3u');
    const [gap, setGap] = useState(24);
    const items: ItemType[] = [
        {
            img: 'https://websiteoss.ecoflow.com/upload/image/1760933155593/15_1.jpg',
            name: t('O_item1_name'),
            text: t('O_item1_text'),
        },
        {
            img: 'https://websiteoss.ecoflow.com/upload/image/1760933155717/15_2.jpg',
            name: t('O_item2_name'),
            text: t('O_item2_text'),
        },
        {
            img: 'https://websiteoss.ecoflow.com/upload/image/1760933156031/15_3.jpg',
            name: t('O_item3_name'),
            text: t('O_item3_text'),
        },
    ];

    useEffect(() => {
        if (typeof window !== 'undefined') {
            setGap(window.innerWidth > 1440 ? 24 : window.innerWidth > 1024 ? 20 : 12);
        }
    }, []);

    return (
        <section className={`${css.section} D3U-O GtmModuleData-section`} id="D3U-O" data-section-id={'D3U-O'} data-section-id2={t('O_title')}>
            <div className="info">
                <p className="label">{t('O_label')}</p>
                <p className="title">{t('O_title')}</p>
            </div>
            <Swiper className="items" slidesPerView={'auto'} spaceBetween={gap} modules={[Navigation]} navigation={true}>
                {items.map((item: ItemType, index: number) => (
                    <SwiperSlide className="item" key={index}>
                        <div className="img">
                            <EcoImg pc={item.img} />
                        </div>
                        <div className="msg">
                            <p className="name">{item.name}</p>
                            <p className="text">{item.text}</p>
                        </div>
                    </SwiperSlide>
                ))}
            </Swiper>
        </section>
    );
};

export default O;
